import { goToLogoutPage, getPostLogoutReturnUrl } from './postLogoutReturnUrl';

/**
 * Passed to `<App authRecovery={...} />` — force-logout uses public `#/logout` before Auth0 end-session.
 */
export const lywAuthRecovery = {
    onForceLogout: () => goToLogoutPage(),
    logoutReturnTo: getPostLogoutReturnUrl,
};
